import startupLogo from "../Images/sprout-white-logo.png";

export default function Startup() {
  return (
    <div className="startup gradientBG">
      <img
        src={startupLogo}
        alt="sprout logo in white"
        className="startupLogo"
      />
      <h2 className="startupHeading">Sprout- Make Journaling Easy</h2>
    </div>
  );
}
